<template>
  <v-dialog v-if="visible" v-model="visible" width="850" persistent>
    <v-card rounded="xxl">
      <v-container>
        <v-row align="center">
          <v-col sm="2" align="center">
            <v-icon
              large
              :style="`color: ${iconColor}; font-size: 90px; width: 200px !important`"
            >
              {{ icon }}
            </v-icon>
          </v-col>
          <v-col sm="10" align="center">
            <v-card-text>
              <v-row>
                <v-col>
                  <h1 :style="`color: ${titleColor}`">{{ Dialog_title }} !</h1>
                  <br />
                  <h3>{{ Dialog_sub_title }}</h3>
                  <br />
                  <v-btn :color="buttonColor" @click="close"> Close </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      Dialog_title: "",
      Dialog_sub_title: "",
      type: "error", // default type
    };
  },
  computed: {
    iconColor() {
      return this.type === "success" ? "green" : "red";
    },
    titleColor() {
      return this.type === "success" ? "green" : "red";
    },
    buttonColor() {
      return this.type === "success" ? "success" : "error";
    },
    icon() {
      return this.type === "success" ? "mdi-check-circle-outline" : "mdi-alert-outline";
    }
  },
  created() {
    this.$root.$on("showPopUp", this.show);
  },
  methods: {
    show({ title, subTitle, type = "error" }) {
      this.Dialog_title = title;
      this.Dialog_sub_title = subTitle;
      this.type = type;

      console.log(this.Dialog_title);
      this.visible = true;
      setTimeout(() => {
        this.close();
      }, 13000);
    },
    close() {
      this.visible = false;
    },
  },
};
</script>

<style scoped>
/* Customize styles as needed */
</style>
